import axios from 'axios';

export const CURRENT_PAGE = 'CURRENT_PAGE';
export const USER_INFO = 'USER_INFO';
export const MY_COMMITTEES = 'MY_COMMITTEES';
export const REQUESTED_COMMITTEES = 'REQUESTED_COMMITTEES';
export const PASSWORD_ERROR = 'PASSWORD_ERROR';
export const SET_LOADING = 'SET_LOADING';
export const REMOVE_LOADING = 'REMOVE_LOADING';
export const TOKEN = 'TOKEN';
export const SET_COMMITTEE_LOADING = 'SET_COMMITTEE_LOADING';
export const SET_STATES = 'SET_STATES';

export function next_page( currentPage ) {
	return ( dispatch ) => {
		const sectionIDs = [
			'user-information', 'committee-section', 'update-information'
		];
		const currentIndex = sectionIDs.indexOf( currentPage );
		const nextPage = sectionIDs[ currentIndex + 1 ];

		dispatch( {
			          type: SET_LOADING, payload: false
		          } );
		dispatch( {
			          type: CURRENT_PAGE, payload: nextPage
		          } );

	};

}

export function setPasswordError( errorMessage ) {
	return ( dispatch ) => {
		dispatch( {
			          type: PASSWORD_ERROR, payload: errorMessage
		          } );
	};
}

export function updateToken( token ) {
	return ( dispatch ) => {
		dispatch( {
			          type: TOKEN, payload: token
		          } );
	};
}

export function removeCommittee( committees, code, partyID ) {
	return ( dispatch ) => {
		const url = `${wpApiSettings.root}isda/v1/committees?code=${code}&partyId=${partyID}`;
		axios.delete( url )
		     .then( response => {
			     if ( response.data.status === 'success' ) {
				     switch ( response.data.message ) {
					     case 'you have left the committee':
						     dispatch( {
							               type: MY_COMMITTEES, payload: response.data.code
						               } );
						     break;

					     case 'request_cancelled':
						     dispatch( {
							               type   : REQUESTED_COMMITTEES,
							               payload: response.data.code
						               } );
						     break;
				     }
			     }
			     dispatch( { type: SET_COMMITTEE_LOADING, payload: code } );
		     } );
	};
}

export function updateInfo( userInfo ) {

	return ( dispatch ) => {
		dispatch( {
			          type: USER_INFO, payload: userInfo
		          } );
	};
}

export function setLoading( loading ) {
	return ( dispatch ) => {
		dispatch( {
			          type: SET_LOADING, payload: loading
		          } );
	};
}

export function setCommitteeLoading( ccode ) {
	return ( dispatch ) => {
		dispatch( {
			          type: SET_COMMITTEE_LOADING, payload: ccode
		          } );
	};
}

export function setStates( states ) {

	return ( dispatch ) => {
		dispatch( {
			          type: SET_STATES, payload: states
		          } );
	};
}

export function getNewStates( countryCode ) {
	return ( dispatch ) => {
		const url = `${wpAjaxJSONpVars.ajaxurl}`;
		const params = {
			action      : 'wpAjaxJSONp',
			method      : 'getStatesNoOption',
			ajaxSSLNonce: wpAjaxJSONpVars.wpAJAXNonce,
			country     : countryCode

		};
		axios.get( url, { params }, get_config() )
		     .then( response => {
			     dispatch( { type: SET_STATES, payload: response.data } );
		     } );
	};

}

function get_config() {
	let config = {
		headers: {
			'X-WP-Nonce': wpApiSettings.nonce
		}
	};
	return config;
}

function serialize( obj ) {
	var str = [];
	for ( var p in obj ) {
		if ( obj.hasOwnProperty( p ) ) {
			str.push( encodeURIComponent( p ) + '=' + encodeURIComponent( obj[ p ] ) );
		}
	}
	return str.join( '&' );
}






